import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import { toggleNPercentRiyal } from "Constants/Constants";
import { FACTOR_RESULT } from "Stores/actionTypes";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";

export default function SettingsDiscount() {
  const { t } = useTranslation();
  const { factorResult } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    DiscountPriceProfile: {
      type: "price",
      value: 0,
      box: 2,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentDiscountPriceProfile',
      label: 'Profile',
    },
    IsPercentDiscountPriceProfile: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'DiscountPriceProfile',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    DiscountPriceFitting: {
      type: "price",
      value: 0,
      box: 2,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentDiscountPriceFitting',
      label: 'Fitting',
    },
    IsPercentDiscountPriceFitting: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'DiscountPriceFitting',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    DiscountPriceGlass: {
      type: "price",
      value: 0,
      box: 2,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentDiscountPriceGlass',
      label: 'Glass',
    },
    IsPercentDiscountPriceGlass: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'DiscountPriceGlass',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    DiscountPriceNet: {
      type: "price",
      value: 0,
      box: 2,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentDiscountPriceNet',
      label: 'Net',
    },
    IsPercentDiscountPriceNet: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'DiscountPriceNet',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    DiscountPriceOther: {
      type: "price",
      value: 0,
      box: 2,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentDiscountPriceOther',
      label: 'materials',
    },
    IsPercentDiscountPriceOther: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'DiscountPriceOther',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    DiscountPrice: {
      type: "price",
      value: 0,
      box: 2,
      row: 2,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'checkbox',
      label: 'discountAmount',
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, key: "IsCalcPriceUnit" },
      ],
    },
  });

  useEffect(() => {
    setControls({ DiscountPriceFitting: { value: factorResult.DiscountPriceFitting } });
    setControls({ DiscountPriceGlass: { value: factorResult.DiscountPriceGlass } });
    setControls({ DiscountPriceNet: { value: factorResult.DiscountPriceNet } });
    setControls({ DiscountPriceOther: { value: factorResult.DiscountPriceOther } });
    setControls({ DiscountPriceProfile: { value: factorResult.DiscountPriceProfile } });
    setControls({ IsPercentDiscountPriceProfile: { value: factorResult.IsPercentDiscountPriceProfile ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentDiscountPriceFitting: { value: factorResult.IsPercentDiscountPriceFitting ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentDiscountPriceGlass: { value: factorResult.IsPercentDiscountPriceGlass ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentDiscountPriceNet: { value: factorResult.IsPercentDiscountPriceNet ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentDiscountPriceOther: { value: factorResult.IsPercentDiscountPriceOther ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ DiscountPrice: { value: factorResult.DiscountPrice } });
    const items = controls.checkbox.items;
    items[0].value = factorResult.IsCalcPriceUnit;
    setControls({ checkbox: { items: items } });
  },[factorResult])

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    const result = {
      ...factorResult,
      [key]: e.currentTarget.checked,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    if(validation) {
      const result = {
        ...factorResult,
        [name]: +value,
      };
      dispatch({ type: FACTOR_RESULT, factorResult: result });
    }
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ [controls[name].relation]: { value: 0 } });
    const result = {
      ...factorResult,
      [name]: value.value,
      [controls[name].relation]: 0,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };

  return (
    <Grid item xs={12} md={6}>
      <Grid xs={12} className="box-re-border p-2">
        <div className="my-3 pb-2">
          <p className="normalTitle">{t('basePriceDiscount')}</p>
        </div>
        {
          Object.keys(controls).filter(key => controls[key].box === 2).map((key, index) => {
            return (
              <Grid container spacing={2} key={key + index}>
                <>
                  {
                    controls[key].row === 1 &&
                    <>
                      <Grid item xs={12}>
                        <Input
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          name={key}
                          validation={
                            controls[key].relation &&
                            controls[controls[key].relation].value.value
                              ? {
                                  ...controls[key].validation,
                                  ...controls[controls[key].relation]
                                    .ValidationPlus,
                                }
                              : controls[key].validation
                          }
                          label={<Translator id={controls[key].label}/>}
                          endIcon={controls[controls[key].relation].value.value ? "%" : <Translator id={'moneyUnit'}/>}
                          type={controls[key].type}
                          radioGroup={{
                            name: controls[key].relation,
                            value: controls[controls[key].relation].value,
                            items: controls[controls[key].relation].arrayItems,
                            onChange: onChangeToggle,
                          }}
                        />
                      </Grid>
                    </>
                  }
                  {
                    controls[key].row === 2 &&
                    <>
                      <Grid item sm={8} xs={6}>
                        <Input
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={controls[key].label}/>}
                          type={controls[key].type}
                          endIcon={<Translator id={'moneyUnit'}/>}
                        />
                      </Grid>
                      <Grid item sm={4} xs={6}>
                        <MuiCheckBoxGroup
                          label=""
                          name={controls[key].relation}
                          value={controls[controls[key].relation].value}
                          items={controls[controls[key].relation].items}
                          onChange={onChangeCheckbox}
                          translate={true}
                          className="horizontalCheckbox"
                        />
                      </Grid>
                    </>
                  }
                </>
              </Grid>
            )
          })
        }
      </Grid>
    </Grid>
  );
}